export default "__VITE_ASSET__qS8nmBYi__"